module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX 源码本地运行")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', [_vm._v("本地查看文档")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', [_vm._v("文档相关命令")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("docs 目录下的相关命令，它们是 npm run doc:build 的一部分，但是可以单独运行")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', [_vm._v("构建部分文档")]), _vm._v(" "), _c('p', [_vm._v("文档页面比较多等待 build 命令会长，因此可以只构建部分文档方便快速查看。")]), _vm._v(" "), _vm._m(4)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("请更新 "), _c('code', [_vm._v("NodeJS")]), _vm._v(" 版本到 "), _c('code', [_vm._v("v7.6.0")]), _vm._v(" 以上，"), _c('code', [_vm._v("build")]), _vm._v(" 命令逐步使用 "), _c('code', [_vm._v("async")]), _vm._v("。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("yarn // 使用 yarn.lock 保证依赖版本一致\nyarn dev\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm run doc:build // 构建文档\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("cd")]), _vm._v(" docs\nyarn\nnpm run dev // 耗时较长\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("node compile // 生成文档路由\nnode component-contributions // 从 git 记录里获取每个组件提交历史\n\nnpm run doc:dev // 运行\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("cd")]), _vm._v(" docs\nnode compile --include datetime // 只构建 datetime 相关文档\nnpm run dev\n")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b360156", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-4b360156"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/vux-development-146.vue
// module id = 2220
// module chunks = 199